import React, { Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import AuthLayout from "./layouts/AuthLayout";
import DefaultLayout from "./layouts/DefaultLayout";
import ProtectedRoute from "./routes/ProtectedRoute";
import { routerData } from "./configs/RouterConfig";
import AuthRoute from "./routes/AuthRoute";
import { useAuth } from "./providers/AuthProvider";
import NoLayout from "./layouts/NoLayout";

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <p className="text-lg font-semibold">Loading...</p>
  </div>
);

const CreateRoutes = () => {
  const userData = useAuth();
  return (
    <BrowserRouter>
      <ScrollToTop>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            {routerData(userData)?.map((route, i) => {
              const Layout =
                route?.layouts === "auth"
                  ? AuthLayout
                  : route?.layouts === "default"
                  ? DefaultLayout
                  : NoLayout;

              return (
                <Route
                  key={route?.key || i?.toString()}
                  path={route?.path}
                  element={
                    route?.type === "protected" ? (
                      <ProtectedRoute
                        {...(route?.disabled && { disabled: true })}
                      >
                        <Layout metaTitle={route?.title || ""} />
                      </ProtectedRoute>
                    ) : route?.type === "auth" ? (
                      <AuthRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AuthRoute>
                    ) : (
                      <Layout metaTitle={route?.title || ""} />
                    )
                  }
                >
                  <Route
                    path={route?.path}
                    exact
                    element={<route.component />}
                  />
                  {route?.subRoute?.map((sub, j) => (
                    <Route
                      key={j?.toString()}
                      path={sub?.path}
                      exact
                      element={<sub.component />}
                    />
                  ))}
                </Route>
              );
            })}
          </Routes>
        </Suspense>
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default CreateRoutes;
